import testimonial1 from '@/assets/testimonial-1.jpg';
import testimonial2 from '@/assets/testimonial-2.jpg';
import testimonial3 from '@/assets/testimonial-3.jpg';
import testimonialMarcelo from '@/assets/testimonial-marcelo.jpg';
import testimonialAna from '@/assets/testimonial-ana.jpg';

/**
 * Testimonial images mapped by index
 * Text content (quote, name, title) comes from i18n: socialProof.testimonials[]
 * 
 * Index mapping:
 * [0] Marina S. - Product Manager
 * [1] Rafael M. - Tech Lead
 * [2] Carla F. - Marketing Manager
 * [3] Marcelo R. - Engineer
 * [4] Ana Carolina - Educator
 */
export const testimonialImages = [
  testimonial1,      // [0] Marina
  testimonial2,      // [1] Rafael
  testimonial3,      // [2] Carla
  testimonialMarcelo, // [3] Marcelo
  testimonialAna     // [4] Ana
];
